import { Input } from '@shared/ui/kit';
import { Modal } from '@shared/ui/modal';
import { useState } from 'react';
import styles from './styles.module.scss';
import { UnstyledButton } from '@shared/ui/unstyled-button';
import { PlusIcon, XmarkIcon } from '@shared/assets/icons';
import { AdditionalGuestUpdate, SminexClubAdditional } from '@entities/clients';

interface EditIAdditionalGuestModalProps {
  onClose: () => void;
  onSave: (value: AdditionalGuestUpdate[]) => void;
  additionalGuest: SminexClubAdditional[];
  participantName?: string;
}

export const EditIAdditionalGuestModal = ({
  onClose,
  onSave,
  additionalGuest,
  participantName,
}: EditIAdditionalGuestModalProps) => {
  const [draftGuests, setDraftGuests] = useState(
    additionalGuest.length ? additionalGuest : [{ fio: '', id: `new-${Date.now()}`, checked: false, isNew: true }]
  );

  const handleSave = () => {
    const value = draftGuests
      .map(({ id, fio, isNew }) => ({
        ticketId: isNew ? undefined : Number(id),
        fullName: fio.trim(),
      }))
      .filter(({ fullName }) => fullName);

    onSave(value);
    onClose();
  };

  const handleChangeGuest = (fio: string, index: number) => {
    const newItems = draftGuests.map((item, i) => {
      if (i === index) {
        return { ...item, fio };
      }

      return item;
    });

    setDraftGuests(newItems);
  };

  const handleAddGuest = () => {
    setDraftGuests((prev) => [...prev, { fio: '', id: `new-${Date.now()}`, checked: false, isNew: true }]);
  };

  const handleDeleteGuest = (index: number) => {
    setDraftGuests(draftGuests.filter((_, i) => i !== index));
  };

  return (
    <Modal
      isOpen
      onClose={onClose}
      title="Добавить +1"
      width={528}
      cancelButton={{
        text: 'Отмена',
        onClick: onClose,
        settings: { width: '106px', minWidth: '106px' },
      }}
      applyButton={{
        text: 'Сохранить',
        onClick: handleSave,
        settings: { width: '112px', minWidth: '112px' },
      }}
      footer={
        <UnstyledButton className={styles.addButton} onClick={handleAddGuest}>
          Добавить еще
          <PlusIcon />
        </UnstyledButton>
      }
    >
      <div className={styles.content}>
        <Input value={participantName} labelText="ФИО клиента" readonly settings={{ width: '100%' }} />

        {!!draftGuests.length && (
          <div className={styles.items}>
            {draftGuests.map(({ id, fio }, index) => (
              <div key={id} className={styles.item}>
                <Input
                  value={fio}
                  changeFunction={(name: string) => handleChangeGuest(name, index)}
                  placeholder="ФИО гостя"
                  settings={{ width: '100%' }}
                />

                <UnstyledButton
                  className={styles.deleteButton}
                  onClick={() => handleDeleteGuest(index)}
                  aria-label={`Удалить гостя ${fio || index + 1}`}
                >
                  <XmarkIcon size="24" color="currentColor" aria-hidden="true" />
                </UnstyledButton>
              </div>
            ))}
          </div>
        )}
      </div>
    </Modal>
  );
};
